// image-preview-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ImagePreviewData {
  imageUrl: string;
  imageName?: string;
}

@Component({
  selector: 'app-image-preview-dialog',
  template: `
    <div class="image-preview-dialog">
      <div class="dialog-header flex justify-between items-center p-4 border-b">
        <h2 class="text-lg font-semibold">{{ data.imageName || 'Image Preview' }}</h2>
        <button (click)="close()" class="text-gray-500 hover:text-gray-700">
          <span class="material-icons">close</span>
        </button>
      </div>
      
      <div class="dialog-content p-6 flex justify-center items-center">
        <img [src]="data.imageUrl" 
             [alt]="data.imageName || 'Preview'" 
             class="max-w-full max-h-96 object-contain rounded-lg shadow-lg">
      </div>
    </div>
  `,
  styles: [`
    .image-preview-dialog {
      min-width: 400px;
      max-width: 800px;
    }
    
    .dialog-content {
      min-height: 200px;
      max-height: 600px;
      background-color: #f5f5f5;
    }
    
    img {
      max-height: 500px;
    }
  `]
})
export class ImagePreviewDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ImagePreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImagePreviewData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
